import * as React from 'react';

// @ts-expect-error - imported from .js/.jsx file
import {LoadingIcon} from 'shells/icon/svg/loading-icon';

import {useCreateTextAutomation} from '../../graphql/hooks/use-create-text-automation';
import {useDeleteTextAutomation} from '../../graphql/hooks/use-delete-text-automation';
import {useGetTextAutomation} from '../../graphql/hooks/use-get-text-automation';
import {useUpdateTextAutomation} from '../../graphql/hooks/use-update-text-automation';

import {FormTextAutomationsComponent} from './form-text-automations-component';

import styles from '../sales-process-form.module.css';

type Props = {
    entityId: string | null | undefined;
    // The stage id
    parentId: string;
    formSubmitBtnRef: (arg1?: HTMLInputElement | null | undefined) => any;
};

export const FormTextAutomations = (props: Props) => {
    const {createTextAutomation} = useCreateTextAutomation();
    const {deleteTextAutomation} = useDeleteTextAutomation();
    const {updateTextAutomation} = useUpdateTextAutomation();
    const {textAutomation, isLoading: isLoadingTextAutomation} = useGetTextAutomation(
        props.entityId
    );

    if (isLoadingTextAutomation) {
        return (
            <div className={styles['loading-container']}>
                <LoadingIcon size={48} />
            </div>
        );
    }

    return (
        <FormTextAutomationsComponent
            stageId={props.parentId}
            formSubmitBtnRef={props.formSubmitBtnRef}
            textAutomation={textAutomation}
            isFetchingLatestVersion={isLoadingTextAutomation}
            createTextAutomation={(automation) =>
                createTextAutomation({
                    stageId: automation.stageId,
                    messageContent: automation.messageContent,
                    delay: automation.delay,
                    sendFromUserId: automation.sendFromUserId,
                    snoozeDuration: automation.snoozeDuration,
                })
            }
            updateTextAutomation={(automation) =>
                updateTextAutomation(
                    {
                        automationId: automation.automationId,
                        messageContent: automation.messageContent,
                        delay: automation.delay,
                        sendFromUserId: automation.sendFromUserId,
                        snoozeDuration: automation.snoozeDuration,
                    },
                    // Needed for cache updates
                    props.parentId
                )
            }
            deleteTextAutomation={(automation) =>
                deleteTextAutomation(
                    {
                        id: automation.id,
                    },
                    // Needed for cache updates
                    props.parentId
                )
            }
        />
    );
};
